module.exports = __webpack_public_path__ + "static/media/12S.8c75e291.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/12S.svg
// module id = 44
// module chunks = 0